<app-site-widget
	title="EBU Daily Usage Summary"
	[elementId]="elementId"
	chartType="column"
	widgetClass="height-600"
	[siteWidgetOptions]="{hasOperation: true, hasWorkingDaysCheckBox: true, hasDate: true, isSitePerformanceWidget: true, hasLithium: true}"
	[widgetOptions]="{}"
	[data]="data"
	[config]="config"
	[tableColumns]="tableColumns"
	[siteId]="siteId"
	[customerId]="customerId"
	[customerName]="customerName"
	[siteName]="siteName"
></app-site-widget>